import { orderBy } from 'lodash'

type SortDirection = 'asc' | 'desc'

export const typedOrderBy = <T, K extends keyof T>(
  array?: readonly T[],
  key?: K | K[],
  direction?: SortDirection | SortDirection[]
): T[] => orderBy(array, key, direction)
